import React, { FC } from 'react';

import './screen-load.scss';

const ScreenLoad: FC = () => {
    return <div className="screen-load">ЗАГРУЗКА...</div>;
};

export default ScreenLoad;
